const styles = {
  container: {},
  tabsGroupThemes: {
    padding: '0px 0px 20px 0px',
  },
};
export default styles;
